import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgSupport = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <path
        fill="url(#support_svg__a)"
        d="m27.55 14.85-.62-.34c-.27-.15-.56-.02-.65.32l-.06.25C27.09 5.85 21.42 2 16 2 10.5 2 4.72 5.96 5.82 15.5c-1.06-.98-1.96.69-1.6 3.38.25 1.95 1.7 3.9 2.51 3.14C8.53 26.32 11.67 30 16 30c3.34 0 5.97-2.2 7.83-5.17a3.7 3.7 0 0 0 2.64-2.98l.02-.1.04-.04a1.69 1.69 0 0 0 1.25-1.37l.6-3.82c.1-.67-.23-1.34-.83-1.67"
      />
      <path
        fill="url(#support_svg__b)"
        d="M16 2.5c2.83 0 5.45 1.1 7.2 3.02 2.02 2.23 2.9 5.52 2.52 9.51a.5.5 0 0 0 .98.18l.03-.1.03-.13.55.3c.41.23.64.7.57 1.17l-.6 3.81c-.07.47-.41.85-.88.96a.7.7 0 0 0-.26.17.5.5 0 0 0-.14.28l-.02.1a3.2 3.2 0 0 1-2.29 2.58.5.5 0 0 0-.29.22C22 26.82 19.58 29.5 16 29.5c-5.06 0-7.84-5.37-8.8-7.68a.5.5 0 0 0-.81-.17c-.04.04-.05.04-.07.04-.41 0-1.4-1.3-1.61-2.87-.2-1.55.04-2.64.36-3 .03-.04.1-.1.14-.1.05 0 .15.04.27.15a.5.5 0 0 0 .83-.42c-.47-4.15.36-7.55 2.42-9.86A9.7 9.7 0 0 1 16 2.5m0-.5C10.5 2 4.72 5.96 5.82 15.5c-.21-.19-.42-.28-.6-.28-.77 0-1.3 1.5-1 3.67.2 1.65 1.29 3.3 2.1 3.3.15 0 .29-.06.41-.17C8.53 26.32 11.67 30 16 30c3.34 0 5.97-2.2 7.83-5.17a3.7 3.7 0 0 0 2.64-2.98l.02-.1.04-.04a1.69 1.69 0 0 0 1.25-1.37l.6-3.82c.1-.67-.23-1.35-.83-1.68l-.62-.33a.46.46 0 0 0-.22-.06c-.2 0-.37.13-.43.38l-.06.25C27.09 5.85 21.42 2 16 2"
      />
      <path
        fillOpacity={0.5}
        d="M26.28 14.83c-.5 1.7-.82 4.32-1.1 7.12a2 2 0 0 1-1.63 1.66l-5.1.9a1.27 1.27 0 0 0-1.22-.47l-1.9.32a1.27 1.27 0 1 0 .43 2.5l1.9-.32c.44-.08.8-.38.95-.76l4.85-.85a3.7 3.7 0 0 0 3.01-3.08l.02-.12a1.69 1.69 0 0 0 1.29-1.4l.6-3.8c.1-.68-.23-1.35-.83-1.68l-.62-.34c-.27-.15-.56-.02-.65.32"
      />
      <defs>
        <linearGradient
          id="support_svg__a"
          x1={7.09}
          x2={24.96}
          y1={6.5}
          y2={24.37}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FF4D" stopOpacity={0.5} />
          <stop offset={1} stopColor="#40C351" />
        </linearGradient>
        <linearGradient
          id="support_svg__b"
          x1={4.13}
          x2={28.39}
          y1={16}
          y2={16}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.49} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.3} />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgSupport;
